export const twitterLibModule = {
  name: 'Twitter Lib',
  shouldInit: () => Boolean(document.querySelector('#liveblog')),
};
